<template>
  <b-modal :id="modalId" centered title="Submit Attendance" @hide="$emit('close')" hide-header-close>
    <b-row v-if="data && profile" class="d-flex flex-column gap-5">
      <b-row>
        <h3>Participant Detail</h3>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Name</label>
            <h4>{{ profile.fullname }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Email</label>
            <h4>{{ profile.email }}</h4>
          </b-col>
        </b-row>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Department</label>
            <h4>{{ profile.department }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Division</label>
            <h4>{{ profile.divisi }}</h4>
          </b-col>
        </b-row>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Position</label>
            <h4>{{ profile.position }}</h4>
          </b-col>
        </b-row>
      </b-row>
      <b-row>
        <h3>Training Detail</h3>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Training Title</label>
            <h4>{{ data?.training_title }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Attendance Date</label>
            <h4>{{ currentDate() }}</h4>
          </b-col>
        </b-row>
      </b-row>
    </b-row>

    <template #modal-footer>
      <b-button variant="primary" @click="handleSubmit" :disabled="isSubmitting" :key="isSubmitting">
        <b-spinner v-if="isSubmitting" small type="grow" class="me-2"></b-spinner>
        <span>{{ isSubmitting ? "Submitting..." : "Submit" }}</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import moment from "moment";
import { formatDate, formatTimeToHHMM } from "../utils/utils";

export default {
  name: "SubmitAttendanceModal",
  props: {
    data: { type: Object, default: null },
    isSubmitting: { type: Boolean, default: false },
    profile: { type: Object, default: null },
    modalId: { type: String, default: "submit-attendance-modal" },
  },

  methods: {
    formatDate,
    formatTimeToHHMM,
    handleSubmit() {
      const payload = { id: this.data.id };

      this.$emit("submit-attendance", payload);
    },

    currentDate() {
      const now = moment();

      const offsetMinutes = now.utcOffset();
      const sign = offsetMinutes >= 0 ? "+" : "-";
      const absMinutes = Math.abs(offsetMinutes);
      const offH = Math.floor(absMinutes / 60);
      const offM = absMinutes % 60;
      const offsetStr =
        offM === 0
          ? `${sign}${String(offH).padStart(2, "0")}`
          : `${sign}${String(offH).padStart(2, "0")}:${String(offM).padStart(2, "0")}`;

      const timeWithOffset = `${now.format("HH:mm:ss")}${offsetStr}`;

      return `${this.formatDate(now.toDate())} - ${this.formatTimeToHHMM(timeWithOffset)}`;
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
